var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{'tooltip': _vm.tooltip}},[_c('div',{staticClass:"livedot"}),(_vm.icon)?_c('i',{staticClass:"mdi",class:[`mdi-${_vm.icon}`]}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.tooltip)?_c('div',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }